import { Link } from "react-router-dom";
import { Container, CTAStrip } from "@/components/Sections";
import { RESOURCES } from "@/lib/content";
import { ArrowUpRight, Download } from "lucide-react";
import { resourcePdfUrl } from "@/lib/api";

export default function Resources() {
  return (
    <div data-testid="page-resources" className="bg-[#F6F1E6]">
      <section className="pt-40 md:pt-52 pb-24">
        <Container>
          <p className="overline mb-6">Section 09 — Resources</p>
          <h1
            data-testid="resources-title"
            className="display-xxl text-5xl md:text-7xl lg:text-[112px] mb-10"
          >
            Practical
            <br />
            <span className="italic text-[#3F5132]">information and tools.</span>
          </h1>
          <p className="text-[#4F5A48] text-lg md:text-xl max-w-3xl leading-relaxed">
            A growing library covering carbon, biodiversity, natural capital and
            the systems that make environmental investment measurable, verifiable
            and durable. Each topic includes a downloadable PDF brief.
          </p>
        </Container>
      </section>

      <section className="border-t border-[#1F2A1B]/10">
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1F2A1B]/10">
            {RESOURCES.map((r, i) => (
              <Link
                to={`/resources/${r.slug}`}
                key={r.slug}
                data-testid={`resource-card-${r.slug}`}
                className="bg-[#F6F1E6] hover:bg-[#ECE4D2] transition-colors duration-500 p-10 md:p-12 min-h-[300px] flex flex-col justify-between group"
              >
                <div>
                  <div className="flex items-center justify-between mb-6">
                    <span className="section-number">
                      — Topic {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="overline text-[#3F5132]">PDF</span>
                  </div>
                  <h3 className="font-serif text-2xl md:text-3xl leading-tight text-[#1F2A1B] group-hover:text-[#3F5132] transition-colors mb-4">
                    {r.title}
                  </h3>
                  <p className="text-[#4F5A48] text-sm leading-relaxed">
                    {r.subtitle}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-10 border-t border-[#1F2A1B]/10 pt-5">
                  <span className="overline">Read & download</span>
                  <ArrowUpRight
                    size={20}
                    className="text-[#8A8775] group-hover:text-[#C45A3C] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                  />
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-24 border-t border-[#1F2A1B]/10 bg-[#EBE3D0]">
        <Container>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <div>
              <p className="overline mb-3">Quick download</p>
              <h2 className="font-serif text-3xl md:text-5xl text-[#1F2A1B] leading-tight">
                Start with{" "}
                <span className="italic text-[#3F5132]">Carbon Farming</span>.
              </h2>
            </div>
            <a
              href={resourcePdfUrl("carbon-farming")}
              data-testid="resources-quick-pdf"
              className="btn-primary inline-flex"
              target="_blank"
              rel="noreferrer"
            >
              <Download size={16} />
              Download PDF brief
            </a>
          </div>
        </Container>
      </section>

      <CTAStrip
        heading="Want a resource tailored to your program?"
        body="We build practical, plain-language guides with ranger programs and Traditional Owner organisations. If there is a topic missing from this list — tell us."
        label="Suggest a resource"
        testid="resources-cta-strip"
      />
    </div>
  );
}
